/* global G */
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'
import displayInstalledByName from 'app/equipmentInformation/action/installationReport/partials/displayInstalledByName'
import displayInstallationDate
  from 'app/equipmentInformation/action/installationReport/partials/displayInstallationDate'
import presetCountry from 'app/_shared/action/address/presetCountry'
import initAddress from 'app/_shared/action/address/init'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'

/**
 * Presets the `serial` field in the form with the equipments serial number
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const presetSerial = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { equipment } = model[G.CHILDREN]
  const { serial, serialLong } = equipment[G.CACHE] || {}
  const { serial: serialComponent } = components;

  (serial || serialLong) && set(serialComponent, serialLong || serial)

  return [components, ...args]
}

const initReportAddress = initAddress(
  { component: 'country' },
  { attribute: 'installationReport' },
)

/**
 * EquipmentInformation Installation Report Create Action
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  presetSerial(module),
  presetCountry(module),
  initReportAddress(
    displayState('state', 'country'),
    displayHouseNumber('number', 'street'),
  )(module),
  displayInstalledByName(module),
  displayInstallationDate(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)
